<template>
    <div>
        <ValidationObserver ref="formValidate">
           <b-row>
               <b-col cols="12">
                   <ValidationProvider name="file" :rules="'required'" v-slot="{ valid, errors }">
                       <b-form-group :label="$t('file')">
                           <div class="d-flex custom-file-upload">
                               <b-form-file v-model="form.file" :state="errors[0] ? false : (valid ? true : null)"
                                            :placeholder="$t('select_file')" :drop-placeholder="$t('drop_file')"
                                            ref="fileInput"
                                            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                               ></b-form-file>
                               <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{
                                       $t('browse') }}</b-button>
                           </div>
                           <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                       </b-form-group>
                   </ValidationProvider>
               </b-col>
           </b-row>
        </ValidationObserver>
        <div class="row mb-5">
            <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-4">
                <b-button variant="primary" @click="updateForm">{{ $t('save') }}</b-button>
            </div>
        </div>

    </div>
</template>

<script>
// Services
import DocumentRequestService from "../../../services/DocumentRequestService";

// Other
import {ValidationObserver, ValidationProvider} from "vee-validate"

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            form: {},
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid) {
                const formData = new FormData();
                formData.append('file', this.form.file);

                DocumentRequestService.uploadTranscript(this.id, formData)
                    .then((response) => {
                        this.$toast.success(this.$t(response.data.message));
                        this.$emit('hide')
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formValidate);
                    });
            }
        }
    }
}
</script>
